import { createSlice } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const initialAuthState = {
  accessToken: "",
  refreshToken: "",
  tokenExpiresAt: undefined,
  user: undefined,
};

// export const callTypes = {
//   login: "login",
// };

export const authSlice = createSlice({
  name: "auth",
  initialState: initialAuthState,
  reducers: {
    login: (state, action) => {
      const { accessToken } = action.payload;
      state.accessToken = accessToken;
    },

    setUserDetails: (state, action) => {
      const { user } = action.payload;
      state.user = user;
    },

    logout: (state, action) => {
      console.log("*******************");
      state.user = initialAuthState.user;
      state.accessToken = initialAuthState.accessToken;
    },
  },
});

export const authReducer = persistReducer(
  {
    storage,
    key: "career-browser-auth",
    whitelist: ["accessToken", "tokenExpiresAt", "user"],
  },
  authSlice.reducer
);
